<template>
  <div>
    <div v-if="filteredProps.length > 0" class="row mt-4">
      <div class="col">
        <h2 class="h3 dg-subheader">Parameters</h2>
        <table class="table table-sm table-hover dg-varients-modifiers table-responsive-sm">
          <thead>
            <tr>
              <th scope="col">Property</th>
              <th scope="col">Type</th>
              <th scope="col" class="w-50">Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filteredProps" :key="index">
              <th scope="row" class="varients-label">{{item.attr}}</th>
              <td>{{item.type}}</td>
              <td>
                <vue-markdown :source="item.docs"></vue-markdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="filteredMethods.length > 0" class="row mt-4">
      <div class="col">
        <h2 class="h3 dg-subheader">Methods</h2>
        <p>
          Components often expose a few utility methods that can be invoked from your application. In order to access these methods, you'll need to obtain a reference to the DOM object and call the method.
          This can be done using
          <span
            class="code"
          >document.getElementById()</span> if the element has a specific ID or by using
          <span
            class="code"
          >document.querySelectorAll()</span> to get a reference to all of the component objects.
        </p>
        <table class="table table-sm table-hover dg-varients-modifiers table-responsive-sm">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col" class="w-50">Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filteredMethods" :key="index">
              <th
                scope="row"
                class="varients-label"
              >{{item.name}}({{item.parameters.map(param => param.name).join(', ')}})</th>
              <td>
                {{item.docs}}
                <div v-if="item.parameters.length > 0" class="mt-3">
                  <i>Parameters:</i>
                  <div v-for="(param, paramIndex) in item.parameters" :key="paramIndex">
                    <b>{{param.name}}</b>
                    : {{param.docs}}
                  </div>
                </div>
                <div v-if="item.returns && item.returns.type !== 'void'" class="mt-3">
                  <i>Returns:</i>
                  <div>
                    <b>{{item.returns.type}}</b>
                    - {{item.returns.docs}}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="filteredEvents.length > 0" class="row mt-4">
      <div class="col">
        <h2 class="h3 dg-subheader">Events</h2>
        <p>
          Components often expose a few events that can be triggered by your application. In order to access these events, you'll need to obtain a reference to the DOM object and and attach an event listener using addEventListener.
          This can be done using
          <span
            class="code"
          >document.getElementById()</span> if the element has a specific ID or by using
          <span
            class="code"
          >document.querySelectorAll()</span> to get a reference to all of the component objects.
        </p>
        <table class="table table-sm table-hover dg-varients-modifiers table-responsive-sm">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col" class="w-50">Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filteredEvents" :key="index">
              <th scope="row" class="varients-label">{{item.event}}</th>
              <td>
                <vue-markdown :source="item.docs"></vue-markdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="docs.usage.variants" class="row mt-4">
      <div class="col">
        <h2 class="h3 dg-subheader">Variants/Modifiers</h2>
        <vue-markdown :source="docs.usage.variants"></vue-markdown>
      </div>
    </div>

    <div v-if="docs.usage.accessibility" class="row mt-4">
      <div class="col">
        <h2 class="h3 dg-subheader">Accessibility</h2>
        <vue-markdown :source="docs.usage.accessibility"></vue-markdown>
      </div>
    </div>

    <div v-if="docs.usage.bestpractices" class="row mt-4">
      <div class="col">
        <h2 class="h3 dg-subheader">Best Practices</h2>
        <vue-markdown :source="docs.usage.bestpractices"></vue-markdown>
      </div>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';

export default {
	name: 'ComponentExample',
	components: {
		VueMarkdown
	},
	props: ['docs'],
	computed: {
		filteredProps() {
			// StencilJS docs generator doesn't apply the @ignore keyword and still adds ignored props.
			// Workaround: Only display props that have been documented.
			return this.docs.props.filter(item => item.docs);
		},
		filteredMethods() {
			return this.docs.methods.filter(item => item.docs);
		},
		filteredEvents() {
			return this.docs.events.filter(item => item.docs);
		}
	}
};
</script>

/* eslint-disable */
<style lang="sass?outputStyle=expanded">
h3 {
	font-size: 1.2rem;
	font-weight: 400;
}

.table-center {
	text-align: center;
	vertical-align: middle !important;
}

.align-middle {
	vertical-align: middle !important;
}
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/ComponentDoc.vue